import React, { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import moment from 'moment';
import styledComponent from '../utils/styledComponent';
import PreviewPalletsTab from '../components/PalletOperations/PreviewPalletsTab';
import GeneratedPalletsTab from '../components/PalletOperations/GeneratedPalletsTab';
import LoadScanningTab from '../components/PalletOperations/LoadScanningTab';
import ReceiveScanningTab from '../components/PalletOperations/ReceiveScanningTab';

const PageContainer = styledComponent('div', {
  padding: '20px 0',
  '@media print': {
    '& .no-print': {
      display: 'none !important',
    },
    '& .nav-tabs': {
      display: 'none !important',
    },
  },
});

const PalletOperations = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [selectedDate, setSelectedDate] = useState(moment());

  return (
    <PageContainer className="container-fluid">
      <Tabs
        activeKey={activeTab}
        onSelect={(key) => setActiveTab(key)}
        id="pallet-operations-tabs"
      >
        <Tab eventKey={1} title="Preview Pallets">
          <PreviewPalletsTab
            selectedDate={selectedDate}
            onDateChange={setSelectedDate}
          />
        </Tab>
        <Tab eventKey={2} title="Generated Pallets">
          <GeneratedPalletsTab
            selectedDate={selectedDate}
            onDateChange={setSelectedDate}
            isActive={String(activeTab) === '2'}
          />
        </Tab>
        <Tab eventKey={3} title="Load Scanning">
          {String(activeTab) === '3' && (
            <LoadScanningTab
              selectedDate={selectedDate}
              onDateChange={setSelectedDate}
            />
          )}
        </Tab>
        <Tab eventKey={4} title="Receive Scanning">
          {String(activeTab) === '4' && (
            <ReceiveScanningTab
              selectedDate={selectedDate}
              onDateChange={setSelectedDate}
            />
          )}
        </Tab>
      </Tabs>
    </PageContainer>
  );
};

export default PalletOperations;
